import { gql } from "@apollo/client";
import { Offer as offer } from "../fragments";
import { OFFER_SELLING_PEOPLE_NAME_FIELDS } from "./SalesPeopleSplit";

const FETCH_OFFER = props => gql`
  query FetchOffer($id: Int) {
    offer(id: $id) {
      ${offer(props)}
    }
  }
`;

const FETCH_OFFERS = props => gql`
  query FetchOffers($input: OfferFilterInput!) {
    offers(input: $input) {
      count
      edges {
        ${offer(props)}
      }
    }
  }
`;

const FETCH_OPTIMISED_OFFERS = props => gql`
  query FetchOffers($input: OfferFilterInput!) {
    offers(input: $input) {
      count
      edges {
        id
        contactId
        artwork {
          id
          title
          artists {
            name
          }
          imagesSummary {
            imgT
          }
        }
        date
        statusId
        currency {
          id
          code
        }
        amount
        tbiAmount
        tbiDate
        holdDate
        priority
        hold {
          id
          name
        }
        dateClosed
        ${OFFER_SELLING_PEOPLE_NAME_FIELDS}
        notes
        projectCode
      }
    }
  }
`;

const FETCH_OFFERS_V2 = props => gql`
  query FetchOffersV2($input: AdvOfferFilterInput!) {
    offersV2(input: $input) {
      count
      edges {
        ${offer(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_OFFERS_LIST = props => gql`
  query FetchOffersList($input: AdvOfferFilterInput!) {
    offersV2(input: $input) {
      count
      edges {
        id
        amount
        artwork {
          id
          title
          artists {
            name
          }
          imagesSummary {
            imgT
          }
        }
        contactId
        currency {
          id
          code
        }
        currencyId
        date
        dateClosed
        holdId
        holdDate
        notes
        status {
          description
        }
        statusId
        tbiDate
        tbiAmount
        updatedAt
        ${OFFER_SELLING_PEOPLE_NAME_FIELDS}
        projectCode
      }
      sqlQuery
    }
  }
`;

export {
  FETCH_OFFER,
  FETCH_OFFERS,
  FETCH_OFFERS_V2,
  FETCH_OFFERS_LIST,
  FETCH_OPTIMISED_OFFERS,
};
